import { Component, Input, OnInit } from '@angular/core';
import {
  NavController,
  ViewController,
  LoadingController,
  AlertController,
  PopoverController,
  NavParams
} from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';

import { RatingsProvider } from '../../providers/ratings/ratings';
import { JobsProvider } from '../../providers/jobs/jobs';

import { IJobStaff, IJob } from '../../interfaces/jobs';
import { IUser } from '../../interfaces/users';
import { IRating } from '../../interfaces/ratings';

@Component({
  selector: 'rating-create',
  templateUrl: 'rating-create.html'
})
export class RatingCreateComponent implements OnInit {
  @Input() rating: string;
  ratings = [];
  ratingDataLoaded = false;
  candidate: IJobStaff;
  job: IJob;
  currentUser: IUser;
  user: IUser;
  userSubscription: any;
  userDataLoaded = false;
  ratingForm: FormGroup;

  loader;

  constructor(
    public navParams: NavParams,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private formBuilder: FormBuilder,
    private ratingsProvider: RatingsProvider,
    private jobsProvider: JobsProvider
  ) {
    this.candidate = this.navParams.data.candidate;
    this.job = this.navParams.data.job;
    this.currentUser = this.navParams.data.user;

    this.ratingForm = this.formBuilder.group({
      rating: ['']
    });
  }

  ngOnInit() {

  }

  saveRating() {
    console.log(this.ratingForm.value.rating);

    this.loader = this.loadingCtrl.create({
      content: 'Saving rating...'
    });
    this.loader.present();

    let rating: IRating = {
      userId: this.candidate.userId,
      createdBy: this.currentUser.uid,
      rating: this.ratingForm.value.rating,
      staffTypeId: this.candidate.applicationType.id,
      jobId: this.job.id
    }

    this.ratingsProvider.createStaffRating(rating).then(() => {
      this.jobsProvider.updateJobApplication(this.job.id, this.candidate.userId, 7).then(() => {
        this.loader.dismiss();
        let alert = this.alertCtrl.create({
          title: 'Rating successful!',
          message:
            `Your rating has been saved!`,
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
            }
          ]
        });
        alert.present();
        this.close();
      })
    });
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/rating/rating-create.ts